import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/workflows/user-workflows/step-taken/{stepTakenId}/add-attachment';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['PUT'];
type Input = THIS_API['body'] & THIS_API['params'];
type Output = THIS_API['response'];

const addAttachmentToStepTaken = async ({ stepTakenId, templateId, templateType }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { stepTakenId });
  const response = await noodleApiClient.put(path, { templateId, templateType });
  return response.data;
};

export default addAttachmentToStepTaken;